const csvTemplate = `SKU
CRS.SC-UMISSPM501001
CRS.SC-UMISSP501
AU.SC-WHGCM551`;

export default csvTemplate;
